import { z } from 'zod';
/**
 * CitationFeedback — the wire shape the "bad citation" popover writes
 * (issue #166 PR A — ask extras). When the CEO clicks the "this
 * citation is wrong" affordance on a synthesized Ask answer, they
 * pick one of four canned reasons and optionally type a free-text
 * suggestion. The feedback feeds the calibration layer so the citation
 * ranker can learn what kinds of sources to deprecate per topic.
 *
 * Persisted at `organizations/{orgId}/citationFeedback/{id}`; surfaced
 * by `POST /api/orgs/:o/citations/:id/feedback`.
 */
/**
 * Closed set of bad-citation reasons. The emoji-prefixed copy lives
 * in i18n strings; the schema stores the kebab-case key.
 *
 *   wrong-source  - 📄 should cite something else
 *   outdated      - ⌛ this was the 2023 template
 *   misread       - ✗ doesn't say that
 *   confidential  - ⚠ shouldn't be cited here
 */
export const CitationFeedbackReason = z.enum([
    'wrong-source',
    'outdated',
    'misread',
    'confidential',
]);
export const CitationFeedback = z.object({
    id: z.string(),
    orgId: z.string(),
    actorUid: z.string(),
    /** Refers to the citation in the synthesis output (server-stamped). */
    citationId: z.string(),
    reason: CitationFeedbackReason,
    /** Optional free-text — the CEO's suggestion of what to cite instead. */
    userSuggestion: z.string().max(1000).optional(),
    createdAt: z.string().datetime(),
});
